// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__ccd {
  .header__cb5 {
    font-weight: 600;
  }

  .header__cb5 + .msg__cd5,
  .header__cb5 + .table__da9,
  .header__cb5 + .actions__ba0 {
    margin-top: calc(var(--ring-unit) * 2);
  }

  .msg__cd5 + .msg__cd5 {
    margin-top: var(--ring-unit);
  }

  .msg__cd5 + .table__da9,
  .msg__cd5 + .actions__ba0 {
    margin-top: calc(var(--ring-unit) * 2);
  }

  .table__da9 + .actions__ba0 {
    margin-top: var(--ring-unit);
  }

  .limitedWidthColumn__de3 {
    max-width: var(--column-width);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .actions__ba0 {
    margin-top: var(--ring-unit);
    display: flex;
    gap: var(--ring-unit);
  }

  .table__da9 {
    padding-bottom: calc(var(--ring-unit) * 2);
    position: relative;

    table thead {
      position: relative;

      &:after {
        top: 100%;
      }
    }

    /* Hack to make a proper spacing */

    table tbody {
      &:before {
        content: '';
        display: block;
        height: calc(var(--ring-unit) * 1.75);
      }

      &:after {
        content: '';
        display: block;
        height: calc(var(--ring-unit) * 1.75);
      }

      td {
        padding-top: calc(var(--ring-unit) * 0.75);
        padding-bottom: calc(var(--ring-unit) * 0.75);
      }
    }

    & table:after {
      content: '';
      position: absolute;
      border-bottom: 1px solid var(--ring-line-color);
      width: calc(100% - calc(var(--ring-unit) * 8));
      transform: translateX(calc(var(--ring-unit) * 4));
    }

    :first-child {
      margin-top: 0;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/common/forms/common/provider-models/provider-models-view/provider-models-view.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,sCAAsC;EACxC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,sCAAsC;EACxC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;;IAElB;MACE,kBAAkB;;MAElB;QACE,SAAS;MACX;IACF;;IAEA,kCAAkC;;IAElC;MACE;QACE,WAAW;QACX,cAAc;QACd,qCAAqC;MACvC;;MAEA;QACE,WAAW;QACX,cAAc;QACd,qCAAqC;MACvC;;MAEA;QACE,0CAA0C;QAC1C,6CAA6C;MAC/C;IACF;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,+CAA+C;MAC/C,8CAA8C;MAC9C,iDAAiD;IACnD;;IAEA;MACE,aAAa;IACf;EACF;AACF","sourcesContent":[".wrapper {\n  .header {\n    font-weight: 600;\n  }\n\n  .header + .msg,\n  .header + .table,\n  .header + .actions {\n    margin-top: calc(var(--ring-unit) * 2);\n  }\n\n  .msg + .msg {\n    margin-top: var(--ring-unit);\n  }\n\n  .msg + .table,\n  .msg + .actions {\n    margin-top: calc(var(--ring-unit) * 2);\n  }\n\n  .table + .actions {\n    margin-top: var(--ring-unit);\n  }\n\n  .limitedWidthColumn {\n    max-width: var(--column-width);\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .actions {\n    margin-top: var(--ring-unit);\n    display: flex;\n    gap: var(--ring-unit);\n  }\n\n  .table {\n    padding-bottom: calc(var(--ring-unit) * 2);\n    position: relative;\n\n    table thead {\n      position: relative;\n\n      &:after {\n        top: 100%;\n      }\n    }\n\n    /* Hack to make a proper spacing */\n\n    table tbody {\n      &:before {\n        content: '';\n        display: block;\n        height: calc(var(--ring-unit) * 1.75);\n      }\n\n      &:after {\n        content: '';\n        display: block;\n        height: calc(var(--ring-unit) * 1.75);\n      }\n\n      td {\n        padding-top: calc(var(--ring-unit) * 0.75);\n        padding-bottom: calc(var(--ring-unit) * 0.75);\n      }\n    }\n\n    & table:after {\n      content: '';\n      position: absolute;\n      border-bottom: 1px solid var(--ring-line-color);\n      width: calc(100% - calc(var(--ring-unit) * 8));\n      transform: translateX(calc(var(--ring-unit) * 4));\n    }\n\n    :first-child {\n      margin-top: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__ccd`,
	"header": `header__cb5`,
	"msg": `msg__cd5`,
	"table": `table__da9`,
	"actions": `actions__ba0`,
	"limitedWidthColumn": `limitedWidthColumn__de3`
};
export default ___CSS_LOADER_EXPORT___;
